import React, { useState } from 'react';

const TYPE_CONFIG = {
  project:   { display: 'New Project',            icon: '📁', section: 'workspace' },
  proposal:  { display: 'New Proposal',           icon: '🚀', section: 'workspace' },
  event:     { display: 'New Event',              icon: '📅', section: 'workspace' },
  client:    { display: 'New Client',             icon: '🏢', section: 'database' },
  vendor:    { display: 'New Vendor',             icon: '🔧', section: 'database' },
  venue:     { display: 'New Venue',              icon: '🏛',  section: 'database' },
  personnel: { display: 'New Personnel Profile',  icon: '👤', section: 'database' },
  talent:    { display: 'New Talent',             icon: '🎤', section: 'database' },
  invite:    { display: 'Invite User',            icon: '✉️', section: 'people' },
  team:      { display: 'New Team',               icon: '👥', section: 'people' },
};

function CloseButton({ onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: 'none',
        border: 'none',
        color: hovered ? '#F5F5F5' : '#565656',
        fontSize: '20px',
        cursor: 'pointer',
        lineHeight: 1,
        padding: '0 2px',
        transition: 'color 0.15s ease',
      }}
    >
      ✕
    </button>
  );
}

function CancelButton({ onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: 'transparent',
        border: `1px solid ${hovered ? '#F5F5F5' : '#565656'}`,
        color: '#F5F5F5',
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 500,
        fontSize: '14px',
        padding: '10px 20px',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease',
      }}
    >
      Cancel
    </button>
  );
}

export default function CreateModal({ isOpen, type, onClose }) {
  if (!isOpen) return null;

  const config = TYPE_CONFIG[type] || { display: type, icon: '📄', section: 'section' };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#2a2a2a',
          border: '1px solid #3a3a3a',
          borderRadius: '10px',
          width: '520px',
          maxWidth: '90vw',
          boxShadow: '0 24px 64px rgba(0,0,0,0.6), 0 0 60px rgba(57, 255, 20, 0.08)',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: '#222222',
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #3a3a3a',
          }}
        >
          <span
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 700,
              fontSize: '20px',
              color: '#FFFFFF',
            }}
          >
            {config.display}
          </span>
          <CloseButton onClick={onClose} />
        </div>

        {/* Body */}
        <div
          style={{
            padding: '32px 24px',
            minHeight: '200px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>{config.icon}</div>
          <div
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 300,
              fontSize: '18px',
              color: '#565656',
              textAlign: 'center',
            }}
          >
            Create {config.display} form coming soon
          </div>
          <div
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 300,
              fontSize: '14px',
              color: '#3a3a3a',
              textAlign: 'center',
              marginTop: '8px',
            }}
          >
            This will be built when the {config.section} section is ready
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '16px 24px',
            borderTop: '1px solid #3a3a3a',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
          }}
        >
          <CancelButton onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
